<template>
  <div class="pt-8 pb-24">
    <article class="pb-8">
      <h3>Kontakt dla klientów</h3>
      <ul>
        <li class="phone">71 771 76 21</li>
        <li v-html="spamProofMail()"></li>
      </ul>
      <p>Nasi konsultanci pracują w godzinach:</p>
      <div class="mb-12 mb-xs-0">
        <span class="d-block mb-6">Obsługa telefoniczna:</span>
        <p>
          poniedziałek - sobota: <strong>9:00 - 22:00</strong> <br />
          niedziela: <strong>10:00 - 21:00</strong>
        </p>
      </div>
      <div class="mb-12">
        <span class="d-block mb-6">Obsługa zamówień internetowych:</span>
        <p>
          poniedziałek - piątek: <strong>8:00 - 22:00</strong> <br />
          sobota - niedziela: <strong>9:00 - 22:00</strong>
        </p>
      </div>
    </article>
    <article>
      <h3>Informacje o firmie</h3>
      <p>
        <strong>Grupa portali TravelOne.pl</strong><br />Travelplanet.pl S.A.
      </p>
      <p>
        ul. Traugutta 45,<br />
        50-418 Wrocław<br />
        Tel: 71 771 76 21<br />
        Fax: 12 424 30 59<br />
        NIP: 897-16-52-554<br />
        REGON: 932281575<br />
        Konto bankowe: Raiffeisen Bank Polska S.A.
        16&nbsp;1750&nbsp;1064&nbsp;0000&nbsp;0000&nbsp;2113&nbsp;2292
      </p>
    </article>
  </div>
</template>

<script>
export default {
  methods: {
    spamProofMail() {
      const coded = "wFQFwJfybF@AwfTFGHrF.8G";
      const key =
        "Qh4Coaj9SN75eAwudOZ1s6impBXHfbnqLlvFcJWzU0x3V2D8gIYPtrRKGTEykM";
      const shift = coded.length;
      let link = "";
      for (let i = 0; i < coded.length; i++) {
        if (key.indexOf(coded.charAt(i)) == -1) {
          let ltr = coded.charAt(i);
          link += ltr;
        } else {
          let ltr =
            (key.indexOf(coded.charAt(i)) - shift + key.length) % key.length;
          link += key.charAt(ltr);
        }
      }
      return (
        "<a href='mailto:" +
        link +
        "' class='font-20'>rezerwacje@travelone.pl</a>"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
ul {
  list-style-type: none;
  margin: 0 0 18px 0;
  padding: 0;
}

.phone {
  @include font-m();
  color: $blue-dark;
  font-size: 36px;
}
</style>
